import React, { ComponentProps, useState } from 'react';
import { Alert, Col, Empty, Row, Space } from 'antd';
import { Coupon } from '@/models/coupon';
import CouponCom from '../Coupon';
import CouponUserOperator from './CouponUserOperator';
import { User } from '@/models/user';
import PosButton from '../PosButton';
import CouponUserTable from '../../pages/Marketing/Coupon/CouponUserTable';
import { DownOutlined, UpOutlined } from '@ant-design/icons';

export type Props = {
  couponUserList: Coupon[];
  user: User;
  actionAreaClassName?: string;
  onCouponUserChange: ComponentProps<typeof CouponUserOperator>['onCouponUserChange'];
};

const CouponUserList: React.FC<Props> = ({
  user,
  couponUserList,
  actionAreaClassName,
  onCouponUserChange,
}: Props) => {
  const [showCouponUserTable, setShowCouponUserTable] = useState(false);

  return (
    <>
      <Alert
        message={
          <Space size={20}>
            仅展示当前可用于结算的优惠券
            <PosButton
              ghost
              size="small"
              type="primary"
              icon={!showCouponUserTable ? <DownOutlined /> : <UpOutlined />}
              onClick={() => {
                setShowCouponUserTable(!showCouponUserTable);
              }}>
              查看全部
            </PosButton>
          </Space>
        }
        showIcon
        className="mb-s"
      />

      {showCouponUserTable ? <CouponUserTable userId={user.id} pageSize={3} /> : null}

      {!couponUserList || !couponUserList.length ? (
        <Empty description={'用户无可用优惠券'} />
      ) : (
        <Row gutter={[20, 10]}>
          {couponUserList.map(coupon => {
            return (
              <Col span={12} key={coupon.id}>
                <CouponCom coupon={coupon} />
              </Col>
            );
          })}
        </Row>
      )}
      <div className={actionAreaClassName}>
        <CouponUserOperator user={user} onCouponUserChange={onCouponUserChange} />
      </div>
    </>
  );
};

export default CouponUserList;
